'use client';
import { cva, type VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
 import NextLink from 'next/link';
import { AnchorHTMLAttributes, ReactNode } from 'react';

const linkClasses = cva(
  'inline-flex items-center transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2',
  {
    variants: {
      variant: {
        primary: 'text-link-text hover:text-text-accent focus:ring-teal-500',
        light: 'text-text-light hover:text-gray-200 focus:ring-gray-500',
        accent: 'text-text-accent hover:text-teal-700 focus:ring-teal-500',
      },
      size: {
        small: 'text-sm',
        medium: 'text-base',
        large: 'text-lg',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'medium',
    },
  }
);

interface LinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>, VariantProps<typeof linkClasses> {
  href: string;
  children: ReactNode;
  external?: boolean;
}

const Link = ({
  href,
  children,
  external = false,
  variant,
  size,
  className,
  ...props
}: LinkProps) => {
  if (external) {
    return (
      <a data-component-id="src/components/ui/Link.tsx:46:6" data-component-path="src/components/ui/Link.tsx" data-component-line="46" data-component-file="Link.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={twMerge(linkClasses({ variant, size }), className)}
        {...props}
      >
        {children}
      </a>
    )
  }

  return (
    <NextLink data-component-id="src/components/ui/Link.tsx:59:4" data-component-path="src/components/ui/Link.tsx" data-component-line="59" data-component-file="Link.tsx" data-component-name="NextLink" data-component-content="%7B%22elementName%22%3A%22NextLink%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      href={href}
      className={twMerge(linkClasses({ variant, size }), className)}
      {...props}
    >
      {children}
    </NextLink>
  )
}

export default Link